import * as Sentry from "@sentry/remix";

/**
 * Utility functions for Sentry that only work in production
 */

export const captureException = (error: any, context?: any) => {
    if (process.env.NODE_ENV === "production") {
        Sentry.captureException(error, context);
    } else {
        // In development, just log the error
        console.error("Sentry would capture this error in production:", error);
        if (context) {
            console.error("Context:", context);
        }
    }
};

export const captureMessage = (message: string, level?: Sentry.SeverityLevel) => {
    if (process.env.NODE_ENV === "production") {
        Sentry.captureMessage(message, level);
    } else {
        // In development, just log the message
        console.log(`Sentry would capture this message in production: ${message}`);
    }
};

export const setUser = (user: Sentry.User | null) => {
    if (process.env.NODE_ENV === "production") {
        Sentry.setUser(user);
    }
};

export const setTag = (key: string, value: string) => {
    if (process.env.NODE_ENV === "production") {
        Sentry.setTag(key, value);
    }
};

export const setContext = (name: string, context: Record<string, any>) => {
    if (process.env.NODE_ENV === "production") {
        Sentry.setContext(name, context);
    }
}; 